
import {FC} from "react";

import React from 'react';

import ApprovalToErrorReasonForm from "../../forms/claim-handling-forms/approval-to-error-reason-form";

interface Interface{
    partSource: any;
    requestId: any;
    mode?: "View" | "Add new";
    onClose?: () => void;
}

const ApprovalToErrorReasonScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <ApprovalToErrorReasonForm
                    requestId={props.requestId}
                    partSource={props.partSource}
                    mode={props.mode}
                />
            
    );
}
export default ApprovalToErrorReasonScreen;
